import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { SnackbarService } from '@dss-libs/shared/utility/common-services';
import { KeycloakAuthService } from '@dss-libs/shared/data-access/auth';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  router: Router = inject(Router),
  _snackbarService = inject(SnackbarService)
) => {
  const isLoggedIn = inject(KeycloakAuthService).isLoggedIn();
  if (isLoggedIn) {
    return true;
  } else {
    router.navigate(['/login'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
};
